var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "home_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.318 30.142v24.674h19.59V42.643h4.185v12.173h19.59V30.142L32 10.63zm49.926 3.896h-2.377V59H6.134V34.038H3.757v-3.619L32 5l28.244 25.42z"
  })));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTAuMzE4IDMwLjE0MjNWNTQuODE1N0gyOS45MDgyVjQyLjY0M0gzNC4wOTI1VjU0LjgxNTdINTMuNjgyN1YzMC4xNDIzTDMyLjAwMDMgMTAuNjI4N0wxMC4zMTggMzAuMTQyM1pNNjAuMjQ0MSAzNC4wMzc1SDU3Ljg2NjlWNTlINi4xMzM3M1YzNC4wMzc1SDMuNzU2NTlWMzAuNDE5MkwzMi4wMDAzIDVMNjAuMjQ0MSAzMC40MTkyVjM0LjAzNzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";